export function SearchIcon() {
  return (
    <div>
      <span className="input-group-text">
        <i className="icon icon-sm">search</i>
      </span>
    </div>
  );
}
